// helpers/ContractInterceptor.js
import axios from 'axios';
import { API } from '../../api/urls';
import store from '../../store';
import { setPaymentRequired } from '../../store/subscription/actions';

class ContractInterceptor {
    constructor() {
        this.contractModalCallback = null;
        this.setupInterceptor();
    }

    setupInterceptor() {
        axios.interceptors.response.use(
            (response) => response,
            (error) => {
                // 401 Unauthorized - Cookie geçersiz/süresi dolmuş → logout
                if (error.response?.status === 401) {
                    const isAuthEndpoint = error.config?.url?.includes('/api/auth/');
                    if (!isAuthEndpoint) {
                        localStorage.removeItem("authUser");
                        localStorage.removeItem("tokenExp");
                        window.location.href = "/login";
                        return Promise.reject(error);
                    }
                }

                // 402 Payment Required — paket limiti aşıldı veya abonelik yok
                if (error.response?.status === 402) {
                    const data = error.response.data
                    store.dispatch(setPaymentRequired({
                        title: data?.message || "Paket Yükseltme Gerekli",
                        message: data?.data?.detail || "Bu işlemi gerçekleştirebilmek için paketinizi yükseltmeniz gerekmektedir.",
                    }))
                    return Promise.reject(error);
                }

                // 403 + featureCode — paket özelliği eksik. Hangi uç reddederse etsin
                // gövde aynı biçimde gelir (backend: PlanFeatureDenial), bu yüzden tek
                // yerden yakalanıp deneme/yükseltme penceresi açılır. Böylece SMS
                // gönderimi, Excel aktarımı gibi menüde karşılığı olmayan aksiyonlar da
                // kullanıcıya bir çıkış yolu sunar; yalnız hata mesajıyla kalmaz.
                if (error.response?.status === 403) {
                    const featureCode = error.response.data?.data?.featureCode;
                    if (featureCode) {
                        window.dispatchEvent(new CustomEvent("plan-feature-denied", {
                            detail: {
                                featureCode,
                                featureLabel: error.response.data?.data?.featureLabel,
                                // Denenebilirlik backend kataloğundan gelir (PlanFeatureDenial);
                                // panel kendi sabit listesini tutmasın diye taşınır.
                                trialable: error.response.data?.data?.trialable,
                            },
                        }));
                    }
                    return Promise.reject(error);
                }

                // 412 Precondition Failed - Contract required
                if (error.response?.status === 412) {
                    // 412: pre-auth cookie backend tarafında zaten set edildi,
                    // frontend token'a dokunmaz.
                    const contractData = error.response.data?.data;
                    if (contractData && this.contractModalCallback) {
                        this.contractModalCallback(contractData);
                    }
                    return Promise.reject(error);
                }

                return Promise.reject(error);
            }
        );
    }

    // Auth header'ını almak için yardımcı method
    // Token artık HttpOnly cookie'de; withCredentials: true ile otomatik gönderilir
    getAuthHeaders() {
        return {
            'Content-Type': 'application/json',
        };
    }

    setContractModalCallback(callback) {
        this.contractModalCallback = callback;
    }

    // DOCX dosyasını blob olarak indir
    async downloadContractDocx() {
        const { blob } = await this.downloadContractDocxWithName();
        return blob;
    }

    // Dosya adı backend'den gelir: Tahsilat360_Sozlesme_<firma>_<kod>_<tarih>.docx
    async downloadContractDocxWithName() {
        try {
            const response = await axios.get(API.current_contract, {
                withCredentials: true,
                responseType: 'blob'
            });
            const cd = response.headers?.['content-disposition'] || '';
            const match = cd.match(/filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i);
            const fileName = match ? decodeURIComponent(match[1] || match[2]) : 'Tahsilat360_Sozlesme.docx';
            return { blob: response.data, fileName };
        } catch (error) {
            console.error('Sözleşme DOCX indirme hatası:', error);
            throw error;
        }
    }

    async signContract(contractData) {
        try {
            const response = await axios.post(API.sign_contract, contractData, {
                headers: this.getAuthHeaders(),
                withCredentials: true,
            });
            // Full response döndür: ContractModal hem headers hem body'den token çekebilsin
            return response;
        } catch (error) {
            throw error;
        }
    }
}

const contractInterceptor = new ContractInterceptor();
export default contractInterceptor;